// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-item-cell-rc7fV {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.business-item-confirmModalContent-hhOOM {
  font-size: 15px;
  color: var(--color-neutral-800);
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/business-item/business-item.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB","sourcesContent":[".cell {\n  max-width: 260px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.confirmModalContent {\n  font-size: 15px;\n  color: var(--color-neutral-800);\n  line-height: 1.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `business-item-cell-rc7fV`,
	"confirmModalContent": `business-item-confirmModalContent-hhOOM`
};
export default ___CSS_LOADER_EXPORT___;
